import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const issueCreateRedirectRoute: InvariantJiraRoute = {
	path: '/jira/secure/CreateIssue(.*)',
	name: 'legacy-create-redirect',
	exact: false,
};
